import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { IS_PUBLIC_API, ONLY_SESSION_ID } from './auth.context';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  let headers = req.headers.set('Accept', 'application/json');

  // Si la API es pública (como el handshake inicial), no tocamos nada.
  if (req.context.get(IS_PUBLIC_API)) {
    return next(req);
  }

  // Inyectamos Session-ID (siempre que no sea pública)
  if (authService.sessionId()) {
    headers = headers.set('X-Session-ID', authService.sessionId()!);
  }

  // Inyectamos Authorization SOLO si no está marcado como 'ONLY_SESSION_ID'
  if (!req.context.get(ONLY_SESSION_ID) && authService.token()) {
    headers = headers.set('Authorization', `Bearer ${authService.token()}`);
  }

  return next(req.clone({ headers }));
};
